import { IPlayerTag } from 'js/hooks/user/store/types';

import { actionTypes } from './constants';
import * as Types from './types';

export const setPlayerTags = (tags: IPlayerTag[]): Types.ISetPlayerTagsAction => ({
    type: actionTypes.SET_PLAYER_TAGS,
    payload: tags
});

export const setIsLoadingError = (isLoadingError: boolean): Types.ISetIsLoadingErrorAction => ({
    type: actionTypes.SET_LOADING_ERROR,
    payload: isLoadingError
});
